import { link } from '../Constants'; 
import axios from 'axios';
export const submitPersonalInformation = async (formData, token) => {
  try {
     await axios.post(link + '/application', formData, {
      headers: {
        'Validation-Header': token,
      },
    })
    .then(res => {
      return res.data;
    })
    .catch((error) => {
      console.error('Error uploading files and form data:', error);
      throw error;
    });
  
  } catch (error) {
      console.error('Error submitting form:', error);
      console.log(error.response)
      throw error;
  }
};
